// extracted by mini-css-extract-plugin
export default {"wrapper":"xscroll_wrapper__a9xLa","scrollBox":"xscroll_scrollBox__G-5Rd","content":"xscroll_content__Zwfo-","scrollBar":"xscroll_scrollBar__BNW9P"};